import { render, staticRenderFns } from "./Collection_Parts.vue?vue&type=template&id=24061f97"
import script from "./Collection_Parts.vue?vue&type=script&lang=js"
export * from "./Collection_Parts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports